import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketButton } from '@market/react';
import { mergeSearchParams } from 'helpers/search_parameter_helpers';
import { onCartPageClick } from 'components/pages/cart/utilities';
import { onCheckoutPageClick } from 'components/pages/checkout/utilities';

const CheckoutButton = (props) => {
  const { t } = useTranslation();

  const {
    id,
    disabled,
    href = 'checkout/v2/information',
    passExistingParams = true,
    trackingData,
  } = props;

  const defaultUrlSearchParams = new URLSearchParams(window.location.search);
  const hasDomain = href?.includes('http');
  const navigateToUrl = new URL(hasDomain ? href : `http://domain.com/${href}`);
  const navigateToUrlSearchParams = new URLSearchParams(navigateToUrl.search);

  const finalSearchParams = passExistingParams
    ? mergeSearchParams(defaultUrlSearchParams, navigateToUrlSearchParams)
    : navigateToUrlSearchParams;

  const paramsString = finalSearchParams.toString()
    ? `?${finalSearchParams.toString()}`
    : '';

  return (
    <MarketButton
      {...(disabled && { disabled: true })}
      id={id}
      rank="primary"
      href={`${
        hasDomain
          ? `${navigateToUrl.origin}${navigateToUrl.pathname}`
          : navigateToUrl.pathname.startsWith('/')
            ? navigateToUrl.pathname.toString().slice(1)
            : navigateToUrl.pathname.toString()
      }${paramsString}`}
      style={{ width: '100%' }}
      onClick={() => {
        onCartPageClick({
          actionItem: 'checkout',
        });
        onCheckoutPageClick({
          eventDesc: 'Checkout button click',
          trackingData,
        });
      }}
    >
      {t('cart.label.checkout')}
    </MarketButton>
  );
};

export default CheckoutButton;
